import Headroom from "headroom.js"

export default function()
{
    const headroom = new Headroom(document.querySelector('#navigation'), {
        offset: {
            up: 50,
            down: 50
        },
        tolerance: {
            up: 0,
            down: 0
        },
        classes: {
            pinned: 'headroom--pinned',
            unpinned: 'headroom--unpinned',
            top: 'headroom--top',
            notTop: 'headroom--not-top'
        },
        onPin: function() {
            document.querySelector('#navigation').classList.add('headroom--pinned')
            document.querySelector('#navigation').classList.remove('headroom--unpinned')
        },
        onUnpin: function() {
            document.querySelector('#navigation').classList.add('headroom--unpinned')
            document.querySelector('#navigation').classList.remove('headroom--pinned')
        },
        top: function() {
            console.log('onTop triggered')
            document.querySelector('html').classList.add('headroom--top')
            document.querySelector('html').classList.remove('headroom--not-top')
        },
        notTop: function() {
            console.log('onNotTop triggered')
            document.querySelector('html').classList.add('headroom--not-top')
            document.querySelector('html').classList.remove('headroom--top')
        }
    })

    // Initialiser l'état
    if (window.scrollY < 50) {
        document.querySelector('html').classList.add('headroom--top')
        document.querySelector('html').classList.remove('headroom--not-top')
    } else {
        document.querySelector('html').classList.add('headroom--not-top')
        document.querySelector('html').classList.remove('headroom--top')
    }

    headroom.init()

    const headroom_element = document.querySelector( '.component--headroom' )

    if ( headroom_element ) {
        const show_duration = headroom_element.getAttribute( 'show-duration' )

        if ( show_duration ) {
            setTimeout( () => {
                headroom_element.classList.add( 'is-shown' )
            }, show_duration )
        }
    }
}